import { render, staticRenderFns } from "./flowPacketModal.vue?vue&type=template&id=1bdd270b&scoped=true&"
import script from "./flowPacketModal.vue?vue&type=script&lang=js&"
export * from "./flowPacketModal.vue?vue&type=script&lang=js&"
import style0 from "./flowPacketModal.vue?vue&type=style&index=0&id=1bdd270b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdd270b",
  null
  
)

export default component.exports